import * as Yup from "yup";

import { requiredStringUk } from "validation";

export const editCategoriesValidationSchema = Yup.object().shape({
  name: requiredStringUk,
  tokens: requiredStringUk,
});
